const fakeStorageSymbol = Symbol();

let storage = null;

const getFakeStorage = () => {
	let items = {};

	return {
		_fake: true,
		setItem: (key, val) => (items[key] = val.toString()),
		removeItem: (key) => {
			if (items.hasOwnProperty(key)) {
				delete items[key];
			}
		},
		getItem: (key) => (items.hasOwnProperty(key) ? items[key] : null),
		clear: () => {
			items = {};
		}
	};
};

const getStorage = () => {

	if (!storage) {
		try {
			storage = self.localStorage;
			const key = "__ssTest";
			storage.setItem(key, "xx");
			storage.removeItem(key);
		}
		catch (e) {
			storage = self[fakeStorageSymbol] = getFakeStorage();
		}
	}

	return storage;
};

const setItem = (key, value) => {

	if (typeof value !== "string") {
		value = JSON.stringify(value);
	}

	return getStorage().setItem(key, value);
};

const removeItem = (key) =>
	getStorage().removeItem(key);

const getItem = (key) =>
	getStorage().getItem(key);

const clear = () =>
	getStorage().clear();

const isFake = () =>
	!!getStorage()._fake;

export {
	setItem,
	getItem,
	removeItem,
	clear,
	isFake,
};
